// Centralized admin base path to obscure the entry point
export const ADMIN_BASE_PATH = '/_panel-7c39f8';

export const adminPath = (suffix = '') => `${ADMIN_BASE_PATH}${suffix}`;



